import { CustomerTab } from '@/features/leads/components/Detail/Tabs/CustomerTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/customer')({
  component: CustomerTab,
});
